
const currentState = {
        isOpen: null,
}

const reducer = (state = currentState, action) => {
    switch (action.type){
        case 'OPEN_LANGUAGE_DRAWER':{
            return{
                ...state,
                    isOpen: action.payload
            }
        }
        case 'CLOSE_LANGUAGE_DRAWER':{
            return{
                ...state,
                    isOpen: action.payload
                }
        }
        default:
            return state;
    }
}

export default reducer;